import { request } from '@/util/vueRequest.js'

interface FetchNoticeListPayloadType {
  uid: number
  limit: number
  page: number
}

export function fetchNoticeList(payload: FetchNoticeListPayloadType) {
  return request({
    url: '/notices',
    method: 'GET',
    headers: {
      token: window.sessionStorage.getItem('bldata'),
    },
    data: payload,
  })
}

/**
 * 全部已读
 * @param payload
 * @returns
 */
export function readAllNotice(payload: any) {
  return request({
    url: '/notices',
    method: 'PUT',
    data: payload,
  })
}

/**
 * 设置已读
 * @param id
 * @returns
 */
export function readNotice(id: any) {
  return request({
    url: `/notices/${id}`,
    method: 'PUT',
  })
}
